let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8tSgw")).then(() => parcelRequire('i2GOL'));